import { Box, Stack, Typography, Pagination } from "@mui/material";
import { useTranslation } from "react-i18next";

const TablePagination = ({
  total,
  page,
  setPage,
  count,
}: {
  total: number;
  page: number;
  setPage: (page: number) => void;
  count: number;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack
      spacing={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px={2}
      py={1}
    >
      <Box>
        <Typography variant="body2">
          {t("table_pagination.summary", {
            total: total,
            count: count,
          })}
        </Typography>
      </Box>
      <Pagination
        count={count}
        page={page + 1}
        onChange={(_, value) => {
          setPage(value - 1);
        }}
        showFirstButton
        showLastButton
        color="secondary"
        shape="rounded"
      ></Pagination>
    </Stack>
  );
};
export default TablePagination;
